import styled from 'styled-components';

const SubContainer = styled.div`
  min-height: 70vh;
`;

export default SubContainer;
